export default "__VITE_ASSET__GbOWJe85__"